export default __webpack_public_path__ + "static/media/mx.d2cabd57.png";